// Extrai o bloco de perguntas de continuação que a Sisa anexa ao fim da resposta
// (<!--perguntas: a | b | c-->) e devolve o texto limpo + até 3 sugestões.
// Defensivo por contrato: se o modelo não mandar o bloco (ou mandar torto), o
// texto volta intacto e sem sugestões — nunca quebra a renderização. O comentário
// HTML já é invisível no react-markdown, então front antigo também não sofre.
const COMENTARIO_RE = /<!--\s*perguntas:\s*([\s\S]*?)-->/gi;
const LINHA_SOLTA_RE = /(?:^|\n)\s*perguntas:\s*([^\n]+)\s*$/i;
const MAX_SUGESTOES = 3;
const MAX_TAMANHO = 90;

export function extrairSugestoes(texto) {
  if (typeof texto !== "string" || !texto) {
    return { texto: "", sugestoes: [] };
  }

  let bruto = null;
  let limpo = texto;

  const comentarios = [...texto.matchAll(COMENTARIO_RE)];
  if (comentarios.length) {
    bruto = comentarios[comentarios.length - 1][1];
    limpo = texto.replace(COMENTARIO_RE, "");
  } else {
    // Modelo às vezes esquece o <!-- -->: aceita a linha solta no FIM do texto.
    const m = LINHA_SOLTA_RE.exec(texto);
    if (m) {
      bruto = m[1];
      limpo = texto.slice(0, m.index);
    }
  }

  const sugestoes = (bruto || "")
    .split("|")
    .map((s) => s.trim())
    .filter(Boolean)
    .filter((s) => s.length <= MAX_TAMANHO)
    .slice(0, MAX_SUGESTOES);

  return { texto: limpo.trim(), sugestoes };
}
